import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { ShieldCheck } from "lucide-react";

const DEFAULT_TEXT = `Brisbane Car Parts & Car Removals ("BCP", "we", "us") is committed to protecting your privacy.

Information We Collect
We collect personal information you provide when placing an order, requesting a quote, or contacting us. This includes your name, email address, phone number, and delivery address.

How We Use Your Information
Your information is used to process orders, arrange delivery, send order confirmations and invoices, and respond to enquiries. We do not sell or share your personal information with third parties except where required to fulfil your order (e.g. shipping carriers).

Data Security
We take reasonable steps to protect your personal information from misuse, interference, loss, and unauthorised access.

Cookies
Our website uses cookies to improve your browsing experience and analyse site traffic. You can disable cookies in your browser settings.

Contact
For privacy-related enquiries, please contact us at info@brisbanecarparts.com.au.

This policy is governed by the Australian Privacy Act 1988.`;

export default function PrivacyPolicy() {
  const { settings } = useSettings();
  const text = settings.privacy_policy?.trim() || DEFAULT_TEXT;

  return (
    <div className="bg-white min-h-screen">
      <StoreHeader />
      <div className="bg-[#0b1a3b] py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-[11px] uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <ShieldCheck className="h-3.5 w-3.5" /> Legal
          </div>
          <h1 className="font-heading text-[44px] font-black uppercase text-white leading-tight">
            Privacy Policy
          </h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="prose prose-zinc max-w-none whitespace-pre-line text-[15px] leading-relaxed text-zinc-700">
          {text}
        </div>
      </div>
      <StoreFooter />
    </div>
  );
}
